let scrollPosition = 0;

export default {
    toggle() {
        const mainContent = document.querySelector('.main');

        if (mainContent.classList.contains('content-lock')) this.unlock();
        else this.lock();
    },

    lock() {
        const mainContent = document.querySelector('.main');

        scrollPosition = -window.pageYOffset;

        mainContent.style.top = `${scrollPosition}px`;
        mainContent.classList.add('content-lock');
        document.body.classList.add('content-locked');

        window.scrollTo(0, 0);
    },

    unlock() {
        const scrollOffset = Math.abs(parseFloat(scrollPosition));
        const mainContent = document.querySelector('.main');

        mainContent.style.removeProperty('top');
        mainContent.classList.remove('content-lock');
        document.body.classList.remove('content-locked');

        window.scrollTo(0, scrollOffset);
    },
};
